import React, { useEffect, useRef } from 'react'
import ChechoutSteps from './ChechoutSteps'
import { useSelector, useDispatch } from "react-redux";
import Metadata from "../layout/Metadata";
import { Typography } from "@material-ui/core";
import { useAlert } from "react-alert";
import {
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import './Payment.css'

import axios from "axios";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import EventIcon from "@material-ui/icons/Event";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import { useNavigate } from 'react-router-dom';
import { clearErrors, createOrder } from '../../actions/orderAction'


function Payment() {

    const orderInfo = JSON.parse(sessionStorage.getItem('orderInfo'))
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const alert = useAlert()
    const stripe = useStripe()
    const elements = useElements()
    const payBtn = useRef(null)

    const { shippingInfo, cartItems } = useSelector((state) => state.cart)
    const { user } = useSelector((state) => state.user)
    const { error } = useSelector((state) => state.newOrder)

    const paymentData = {
        amount: Math.round(orderInfo.totalPrice * 100),

    }
    const order = {
        shippingInfo,
        orderProducts: cartItems,
        productsPrice: orderInfo.subtotal,
        taxPrice: orderInfo.tax,
        shippingPrice: orderInfo.shippingCharges,
        totalPrice: orderInfo.totalPrice,
    }
    const submitHandler = async (e) => {
        e.preventDefault()
        payBtn.current.disabled = true;
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                }
            }
            const { data } = await axios.post(
                "/payment/payment/process",
                paymentData,
                config,
            )
            console.log("paymentdata", data)
            const client_secret = data.client_secret;
            console.log(!stripe || !elements)
            if (!stripe || !elements) return;
            console.log(stripe, elements)
            const result = await stripe.confirmCardPayment(client_secret, {
                payment_method: {
                    card: elements.getElement(CardNumberElement),
                    billing_details: {
                        name: user.name,
                        email: user.email,
                        address: {
                            line1: shippingInfo.address,
                            city: shippingInfo.city,
                            state: shippingInfo.state,
                            postal_code: shippingInfo.pinCode,
                            country: shippingInfo.country,
                        },
                    }
                }
            })
            // console.log(result)
            if (result.error) {
                payBtn.current.disabled = false;
                alert.error(result.error.message);
            } else {
                if (result.paymentIntent.status === "succeeded") {
                    order.paymentInfo = {
                        id: result.paymentIntent.id,
                        status: result.paymentIntent.status,

                    }
                    dispatch(createOrder(order))

                    navigate("/success")
                } else {
                    alert.error("There's some issue while processing payment")
                }
            }

        } catch (error) {
            payBtn.current.disabled = false;
            console.log(error)
            alert.error(error.response.data.message)

        }
    }

    useEffect(() => {
        if (error) {
            alert.error(error)
            dispatch(clearErrors())
        }
    }, [dispatch, alert, error]);
    return (
        <>
            <Metadata title="Payment" />
            <ChechoutSteps activeStep={2} />
            <div className='paymentContainer'>
                <form className="paymentForm"
                    onSubmit={(e) => submitHandler(e)}>
                    <Typography>Card Info</Typography>
                    <div>
                        <CreditCardIcon />
                        <CardNumberElement className='paymentInput' />
                    </div>
                    <div>
                        <EventIcon />
                        <CardExpiryElement className='paymentInput' />
                    </div>
                    <div>
                        <VpnKeyIcon />
                        <CardCvcElement className='paymentInput' />
                    </div>
                    <input type="submit"
                        value={`Pay - ₹${orderInfo && orderInfo.totalPrice}`}
                        ref={payBtn}
                        className="paymentFormBtn" />
                </form>
            </div>

        </>)

}

export default Payment